import { app } from '../../../../../../../bootstrap/core';

import { confirmWarrantAccountswitchOptionsComponent } from './accountswitchOptions.component';

app.component(
  confirmWarrantAccountswitchOptionsComponent.name,
  confirmWarrantAccountswitchOptionsComponent,
);
